const state = {
  components: []
}

const cacheState = () => {
  const sections = Array.from(document.querySelectorAll('[data-section="hub-faq"]'))
  state.components = sections.reduce((components, section) => {
    const currentComponent = {
      section,
      questioncontainers: section.querySelectorAll('.hub-faq__question-item'),
    }
    return [...components, currentComponent]
  }, [])
}

const addEventListeners = () => {
  state.components.forEach(component => {
    component.section.addEventListener('click', toggleQuestion.bind(component))
  })
}

function toggleQuestion(e) {
  const clickedQuestion = e.target.closest('.hub-faq__question');
  const questionContainer = e.target.closest('.hub-faq__question-item');
  if (!clickedQuestion) return;
  questionContainer.classList.toggle('open');
  this.questioncontainers.forEach(container => {
    if (container !== questionContainer) {
      container.classList.remove('open')
    }
  })
}

const init = () => {
  cacheState();
  addEventListeners();
}

export default init;